import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    label: string;
    subtext: string;
    dotColor: string;
    dotBg: string;
}

const useStyles = makeStyles(() => ({
    health: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        background: tokens.surface,
        border: `1px solid ${tokens.line}`,
        borderRadius: "11px",
        padding: "10px 16px",
        boxShadow: tokens.shadow,
    },
    dot: {
        width: "9px",
        height: "9px",
        borderRadius: "50%",
        flex: "none",
    },
    label: {
        fontSize: "13.5px",
        fontWeight: 600,
        color: tokens.ink,
        display: "block",
    },
    subtext: {
        fontSize: "11.5px",
        color: tokens.hint,
    },
}));

export const HealthBadge: React.FC<Props> = ({ label, subtext, dotColor, dotBg }) => {
    const classes = useStyles();

    return (
        <div className={classes.health}>
            <span className={classes.dot} style={{ background: dotColor, boxShadow: `0 0 0 3px ${dotBg}` }} />
            <div>
                <Typography component="b" className={classes.label}>{label}</Typography>
                <Typography component="span" className={classes.subtext}>{subtext}</Typography>
            </div>
        </div>
    );
};
